import React from 'react'
import { connect } from 'react-redux'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import { addFlashMessage } from "../../actions/flashMessages"
import SetsUserItem from "./SetsUserItem"
import { isEmpty, isEqual } from 'lodash'
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import SettingsForm from './SettingsForm'

class SetsUser extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('user');
    this.props.fetchSets('usrg');
    if (this.props.user_s) {
      this.props.fetchSets('org');
    }
    this.setState({
      adding: false,
      data: this.newItem,
      errors: {}
    });
  }

  modelName = 'user'

  newItem = {
    user_fname: '',
    user_lname: '',
    user_tel: '',
    user_text: '',
    user_login: '',
    user_usrg_id: 0,
    user_org_id: 0,
    user_active: 1,
    user_emailconf: 0
  }

  saveItem = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(data, this.newItem)) {
      this.cancelAdding();
    }
    else {
      this.props.addSets(this.modelName, data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.addFlashMessage({
          type: 'success',
          text: 'На указанный e-mail высланы данные для доступа.'
        });
        this.props.addFlashMessage({
          type: 'success',
          text: 'Не забудьте дать пользователю доступ к компаниям.'
        });
        this.cancelAdding();
      });
    }
  }

  render() {
    if(isEmpty(this.props.users)
      || isEmpty(this.props.users.data)
      || isEmpty(this.props.usrgs)
      || (this.props.user_s && isEmpty(this.props.orgs))
    ){
      return(<div>Не загружены данные</div>);
    }
    const {
      users: {
        data: users,
        search,
        sort
      },
      usrgs,
      orgs,
      user_s
    } = this.props;
    const { data, errors } = this.state;

    let fltrUsers = [];
    for(let key in users){
      if(users.hasOwnProperty(key)){
        let found = true;
        if(search !== ''){
          const searchValue = "" + users[key].user_login + users[key].user_fname
            + users[key].user_lname;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(found){
          fltrUsers.push(users[key]);
        }
      }
    }

    const srtUsers = fltrUsers.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.user_id < b.user_id)
         return sort.asc ? -1 : 1
      if(a.user_id > b.user_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedUsers = srtUsers ? srtUsers.map(user =>
      <SetsUserItem key={user.user_id}
        data={user}
        usrgs={usrgs}
        orgs={orgs}
        user_s={user_s}
      />
    ) : [];

    let usrgsOpt = [];
    for (let key in usrgs){
      if(usrgs.hasOwnProperty(key) && (usrgs[key].usrg_active === 1
        || usrgs[key].usrg_id === data.user_usrg_id)) {
        usrgsOpt.push({value:usrgs[key].usrg_id,label:usrgs[key].usrg_desc});
      }
    }
    usrgsOpt.sort(sortOpts);

    let orgsOpt = [];
    for (let key in orgs){
      if(orgs.hasOwnProperty(key) && (orgs[key].org_active === 1
        || orgs[key].org_id === data.user_org_id)) {
        orgsOpt.push({value:orgs[key].org_id,label:orgs[key].org_desc});
      }
    }
    orgsOpt.sort(sortOpts);

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.user_login}
              name="user_login"
              onChange={this.updateInput}
              placeholder="Email"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
        </td>
        <td>
          <Select
            clearable={false}
            options={usrgsOpt}
            value={data.user_usrg_id}
            onChange={e => this.updateSelect(e,'user_usrg_id')}
            placeholder="Группа пользователей"
          />
        </td>
        {!!user_s && (
          <td>
            <Select
              clearable={false}
              options={orgsOpt}
              value={data.user_org_id}
              onChange={e => this.updateSelect(e,'user_org_id')}
              placeholder="Организация"
            />
          </td>
        )}
        <td>
        </td>
        <td>
        </td>
        <td>
        </td>
        <td>
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка пользователей</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrUsers.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-sm-2" onClick={() => {this.handleSort('user_login')}}>Email</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('user_active')}}>Статус</th>
              <th className="col-sm-2" onClick={() => {this.handleSort('user_usrg_id')}}>Группа</th>
              {!!user_s && (
                <th className="col-sm-1" onClick={() => {this.handleSort('user_org_id')}}>Организация</th>
              )}
              <th className="col-sm-1" onClick={() => {this.handleSort('user_fname')}}>Имя</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('user_lname')}}>Фамилия</th>
              <th className="col-sm-2" onClick={() => {this.handleSort('user_tel')}}>Телефон</th>
              <th className="col-sm-2" onClick={() => {this.handleSort('user_text')}}>Должность</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedUsers}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              {!!user_s && <td></td>}
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    users: store.users,
    usrgs: store.usrgs.data,
    orgs: store.orgs.data,
    user_s: store.auth.rights.user_s_post
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets,
  searchSets, addFlashMessage })(SetsUser);



// WEBPACK FOOTER //
// ./src/components/settings/SetsUser.js